import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["form", "input"]

  connect() {
    super.connect()
    this.closeOnOutsideClick = this.closeOnOutsideClick.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    const formContainer = this.formTarget
    const isActive = formContainer.classList.contains('active')

    if (isActive) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.formTarget.classList.add('active')

    // Foca no input após a animação
    setTimeout(() => {
      this.inputTarget.focus()
    }, 300)

    // Adiciona listener para fechar ao clicar fora
    document.addEventListener('click', this.closeOnOutsideClick)
  }

  close() {
    this.formTarget.classList.remove('active')

    // Remove listener
    document.removeEventListener('click', this.closeOnOutsideClick)
  }

  closeOnOutsideClick(event) {
    // Se o clique foi fora do componente de busca, fecha
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener('click', this.closeOnOutsideClick)
  }
}